import React from 'react';
import DOMPurify from 'dompurify';

// Configuration matching ReactQuill toolbar: bold, italic, underline, lists, link
const ALLOWED_TAGS = [
  'p', 'br',  // Paragraphs and line breaks
  'strong', 'em', 'u',  // Bold, italic, underline
  'ul', 'ol', 'li',  // Lists
  'a',  // Links
  'div', 'span',  // Containers
];

const ALLOWED_ATTR = {
  'a': ['href', 'title', 'target', 'rel'],
  '*': ['class'],  // Allow classes for Quill formatting
};

const sanitizeHTML = (html) => {
  if (!html) return '';
  
  // Step 1: Decode HTML entities first (handles &lt;script&gt; -> <script>)
  // This is important because content might be HTML-encoded
  let decoded = html;
  try {
    // Create a temporary element to decode HTML entities
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    decoded = textarea.value;
  } catch (e) {
    // If decoding fails, use original
    decoded = html;
  }
  
  // Step 2: Sanitize with DOMPurify
  return DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,  // Disable data-* attributes
    ALLOW_ARIA_ATTR: true,  // Allow ARIA for accessibility
    KEEP_CONTENT: true,  // Keep content even if tags are removed
    ADD_ATTR: ['target'],  // Add target="_blank" to links automatically
  });
};

const SafeHTML = ({ html, className, tag = 'div', ...props }) => {
  if (!html) return null;
  
  const sanitized = sanitizeHTML(html);
  const Tag = tag;
  
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
      {...props}
    />
  );
};

export default SafeHTML;

